






















import { Vue, Component } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import { ssoLogin } from '../../modules/util/SapUtil'
import LoadingAnimationWithoutBg from '../../components/Parts/LoadingAnimationWithoutBg.vue'

@Component({
  components: { LoadingAnimationWithoutBg }
})
export default class RegisterICon extends Vue {
  // ---------------------------------------------------------------------------
  // hock
  private beforeCreate() {
    membershipState.checkLogin()
  }

  private mounted() {
    // 野良登録ボタンにイベントを追加
    const elements = document.querySelectorAll('.js-memberRegisterButton')
    elements.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault()

        this.register()
      })
    })
  }

  // ---------------------------------------------------------------------------
  // conputed
  get isLogin(): boolean {
    return membershipState.isLogin
  }

  /**
   * ログイン判定処理 状態フラグ
   * @true ログイン判定中
   * @false ログイン判定完了
   */
  get isLoadingLogin(): boolean {
    return membershipState.isLoadingLogin
  }

  // ---------------------------------------------------------------------------
  // method
  private register() {
    membershipState.addIsLoadingLogin(true)
    ssoLogin(window.location.href, 'gigya-register-screen')
  }
}
